import PropTypes from 'prop-types';
import React from 'react';

import NormalButton from '../../atoms/NormalButton';

class CancelUserEditButton extends React.Component {
  static get propTypes() {
    return {
      children: PropTypes.any,
      onClick: PropTypes.func,
    };
  }

  render() {
    return (
      <NormalButton color="dark" onClick={this.props.onClick}>
        <i className="fas fa-times" />
      </NormalButton>
    );
  }
}

export default CancelUserEditButton;
